import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { ColDef } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";
import {
  deleteComment,
  fetchAllComments,
  selectAllComments,
  selectLoading,
} from "features/admin/Comments/commentsAdminSlice";
interface AllCommentsTableProps {}
const columns: ColDef[] = [
  { sortable: false, field: "reviewerName", headerName: "Име", width: 300 },
  { sortable: false, field: "rating", headerName: "Рейтинг", width: 150 },
  { sortable: false, field: "title", headerName: "Заглавие", width: 150 },
  { sortable: false, field: "content", headerName: "Коментар", width: 150 },
  {
    sortable: false,
    field: "location",
    headerName: "Местоположение",
    width: 150,
  },
];

const CommentsTable: React.FC<AllCommentsTableProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const comments = useSelector(selectAllComments);
  const isLoading = useSelector(selectLoading);
  useEffect(() => {
    dispatch(fetchAllComments());
  }, [dispatch]);

  const add = () => {
    navigate("/comments/add");
  };
  const refresh = () => {
    dispatch(fetchAllComments());
  };
  const remove = (ids: string[]) => {
    ids.forEach((id: string) => {
      const _refId = comments.find(
        (item: { id: number }) => item.id === parseInt(id)
      )?.refId;
      _refId &&
        batch(() => {
          dispatch(setResponseMessage({ message: "", hasError: false }));
          dispatch(deleteComment(_refId));
        });
    });
    dispatch(fetchAllComments());
  };

  const edit = (id: string) => {
    const _refId = comments.find(
      (item: { id: number }) => item.id === parseInt(id)
    )?.refId;
    _refId && navigate(`/comments/edit/${_refId}`);
  };

  return (
    <GridTable
      add={add}
      refresh={refresh}
      remove={remove}
      edit={edit}
      data={comments}
      columns={columns}
      isLoading={isLoading}
      searchProperty="title"
    />
  );
};

export default CommentsTable;
